/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { NumberOfCallersReportParameterValue } from '../models/number-of-callers-report-parameter-value';
import { NumberOfCallersParameterFormModel } from '../report-parameter-list/models/report-parameter-form-value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: NumberOfCallersReportParameterComponent }],
    selector: 'ndt-number-of-callers-report-parameter',
    templateUrl: './number-of-callers-report-parameter.component.html',
    standalone: false
})
export class NumberOfCallersReportParameterComponent implements OnDestroy {
   config: ReportParameterConfig;

   set form(form: UntypedFormGroup) {
      this._form = form;
      const formValue: NumberOfCallersParameterFormModel = this.form.value;
      if (formValue) {
         this.initializeContentFormValue(formValue);
      }
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   private initializeContentFormValue(formValue: NumberOfCallersReportParameterValue): void {
      this.form.setValue({
         ...formValue,
         value: formValue.value,
      });
   }
}
